import { ApiClient } from "@/services/client";

let client = new ApiClient();

export default {
  getToken(data, headers) {
    return client.post(`connect/token`, data, { headers: headers });
  },
};
